import _ from 'lodash';
import { DEFERRED_SEARCH_EVENT_KEY, eventStore } from './storage';
import { recordStatisticsEvent } from '../services/statistics-service';

const buildSearchStatEvent = q => {
  let type;
  if (_.get(q, 'type') && _.get(q, 'suggested_term')) {
    type = 'suggested_searched';
  } else if (_.get(q, 'type') && _.get(q, 'query')) {
    type = 'recent_type_searched';
  } else if (_.get(q, 'query') && _.get(q, 'id')) {
    type = 'recent_text_searched';
  } else {
    type = 'text_searched';
  }
  const value = _.get(q, 'query', _.get(q, 'suggested_term'));
  return { type, value };
};

export async function saveEvent(q) {
  return eventStore.setItem(DEFERRED_SEARCH_EVENT_KEY, buildSearchStatEvent(q));
}

export async function sendEvent() {
  const v = await eventStore.getItem(DEFERRED_SEARCH_EVENT_KEY);

  if (!v) {
    return;
  }

  const sq = _.get(window, 'Livewire.request.searchQuery', {});
  const sqValue = sq.meta ? `${sq.meta} ${sq.query}` : sq.query;
  if (sqValue !== v.value) {
    return;
  }

  const data = {
    id: sq.id / 1,
    event: v.type,
    statisticable: 'search_query',
  };
  recordStatisticsEvent(data).then(async () => {
    await eventStore.removeItem(DEFERRED_SEARCH_EVENT_KEY);
  });
}
